import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module manager */

/**
 * Browserunterstützung
 */
export class OpaccBrowser {
	constructor() {
		this.browserLink = {
			'chrome': 'https://www.google.com/chrome',
			'chrome-de': 'https://www.google.com/chrome',
			'chrome-en': 'https://www.google.com/chrome',
			'chrome-fr': 'https://www.google.com/chrome',
			'firefox': 'https://www.mozilla.org',
			'firefox-de': 'https://www.mozilla.org/de/',
			'firefox-en': 'https://www.mozilla.org/en-gb/',
			'firefox-fr': 'https://www.mozilla.org/fr/',
			'edge': 'https://www.microsoft.com/edge',
			'edge-de': 'https://www.microsoft.com/de-ch/windows/microsoft-edge',
			'edge-en': 'https://www.microsoft.com/en-gb/windows/microsoft-edge',
			'edge-fr': 'https://www.microsoft.com/fr-ch/windows/microsoft-edge'
		};
		this.container = document.querySelector('.not-supported');
		this.attachEventListener();
	}

	/**
	 * Event Registrierung im DOM
	 */
	attachEventListener() {
		if (this.container) {
			this.container.addEventListener('click', event => {
				// Browser-Link aufrufen
				if (event.target.hasAttribute('data-op-browser')) {
					var browser = event.target.getAttribute('data-op-browser');
					var link = this.browserLink[browser];
					if (link) {
						window.location.href = link;
					}
				}
				// Meldung ausblenden und asynchroner Aufruf (falls vorhanden)
				if (event.target.classList.contains('opc-button')) {
					this.container.style.display = 'none';
					var url = this.container.getAttribute('data-op-acknowledge');
					if (url) {
						opaccAjaxPlugin.fetchAsynPostForm(url, {});
					}
				}
			});
		}
	}
}